let isNullOrUndefined = (...values) => {
    return values.every(value => {
        return value === null || value === undefined
    })
}

let isEmptyArray = arr => {
    return Array.isArray(arr) && arr.length === 0
}

let required = value => {
    if (isNullOrUndefined(value) || isEmptyArray(value)) {
        return false
    }

    return !!String(value).trim().length
}

let requiredIf = (prop, val) => (value, obj) => {
    if (obj) {
        if (obj[prop] == val) {
            return required(value)
        }
    }
    return true
}

let numeric = value => {
    let en = /^[0-9]+$/

    const strValue = String(value)

    return en.test(strValue)
}

let maxLen = len => value => {
    if (isNullOrUndefined(value)) {
        return length >= 0
    }

    return String(value).length <= len
}

let minLen = len => value => {
    if (isNullOrUndefined(value)) {
        return false
    }

    return String(value).length >= len
}

export { required, requiredIf, numeric, maxLen, minLen }